export default "__VITE_ASSET__e371853a__"